// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import React from "react";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";
import parse from "html-react-parser";

import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";

import forest from "../../../../images/forest.webp";
import carbon from "../../../../images/carbon.svg";

const BenefitsBlock = ({
  classes,
  carbon_block_title,
  carbon_block_description,
}) => {
  return (
    <div className={classes.mainContainer}>
      <MediaQuery minWidth={900}>
        <img className={classes.image} src={forest} alt={"forest"} />
      </MediaQuery>
      <div className={classes.carbonContainer}>
        <div className={classes.carbonInnerContainer}>
          <div className={classes.carbonImageContainer}>
            <img className={classes.carbonImage} src={carbon} alt={"carbon"} />
          </div>
          <div>
            <h4 className={classes.titleText}>{carbon_block_title}</h4>
          </div>
          <div>
            <p className={classes.descriptionText}>
              {parse(carbon_block_description)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

BenefitsBlock.propTypes = {
  classes: PropTypes.object,
  carbon_block_title: PropTypes.string,
  carbon_block_description: PropTypes.string,
};

BenefitsBlock.defaultProps = {
  classes: {},
  carbon_block_title: "",
  carbon_block_description: "",
};

export default withStyles(styles)(BenefitsBlock);
